import WidgetConfig from "views/logic/widgets/WidgetConfig";
export default class TextWidgetConfig extends WidgetConfig {
  constructor(text) {
    super();
    this._text = text;
  }
  get text() {
    return this._text;
  }
  toJSON() {
    return {
      text: this._text
    };
  }
  static empty() {
    return new TextWidgetConfig("");
  }
  static fromJSON(value) {
    return new TextWidgetConfig(value.text);
  }
  equals(other) {
    return other instanceof TextWidgetConfig && this._text === other.text;
  }
  // eslint-disable-next-line class-methods-use-this
  equalsForSearch(_other) {
    return true;
  }
}
